define('superAdminMbAnaResTabs',[
  'module',
  'underscore'
], function(
  module,
  _
) {
  'use strict';

  module.exports = [
    {
      name: 'detail',
      title: _.i18n('mbanares.details.tabTitle'),
      isDefault: true
    }
  ];
});
